.signupsGrid {
  display: grid;
  grid-template-columns: 100px 150px 300px 300px;
  grid-gap: 4px 8px;
  align-items: flex-end;
  margin: 20px;
}

.rowForm {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  justify-content: space-between;

  & > :first-child {
    flex-grow: 1;
  }

  & > :last-child {
    margin-left: 10px;
  }
}
